import React, { Component } from 'react';
import className from 'classnames/bind';
import { Button } from 'web/components/common/modal/common/input';
import Logo from 'web/components/common/modal/common/Logo';

import styles from './MarketingAgree.scss';
const cx = className.bind(styles);

class MarketingAgree extends Component {
  render() {
    let msg = `마케팅 정보 수신에 동의하시면
    각종할인 및 이벤트 혜택을 드려요`;
    return (
      <div
        className={cx('MarketingAgree')}
        onClick={e => e.stopPropagation()}
        onMouseDown={e => e.stopPropagation()}
      >
        <Logo title={'할인 쿠폰 발급 안내'} />
        <form>
          <p className="message">
            {`마케팅 정보 수신에 동의하시면`}
            <br />
            {`각종할인 및 이벤트 혜택을 드려요`}
          </p>
          <div className="buttons">
            <Button type="submit" onClick={this.props.agree}>
              동의
            </Button>
            <Button className={['cancel']} onClick={this.props.disagree}>
              동의하지 않음
            </Button>
          </div>
        </form>
      </div>
    );
  }
}
export default MarketingAgree;
